/**
 * Single source of truth for top-level scene IDs and the URL-id → backend
 * poi-filter id mapping. Used by:
 *   - `App.tsx` for `handleEnterScene` (MenuOverlay click)
 *   - `createScene.ts` for navigation POIs on the `overall` root scene
 *
 * Keep this list in sync with `splatRegistry.ts` / route handling.
 */
export const KNOWN_SCENES: ReadonlySet<string> = new Set([
  'overall',
  'kaaba',
  'arafat',
  'mina',
  'muzdalifah',
]);

/**
 * URL scene id → backend scene id. Used both for POI filtering in
 * `$sceneSights` (which keys on `sight.sceneId`) and for the chat intro
 * lookup in `$introsMap` (keyed by backend scene id).
 *
 * `overall` maps to `'overall-scene'` so the assistant intro arrives even
 * though the scene has no backend sights — its POIs are static
 * `navigationPois` declared in `overall.ts` (the empty `$sceneSights`
 * filter is the reason `overall.ts` sets `disablePoiChips: true`).
 */
export const SCENE_POI_ID: Record<string, string> = {
  overall: 'overall-scene',
  kaaba: 'main',
  arafat: 'arafat-scene',
  mina: 'mina-scene',
  muzdalifah: 'muzdalifa-scene',
  // Era scenes are NOT listed: their config id IS the backend id
  // (e.g. `kaaba-600ce`) — every lookup falls back via `?? id`.
};
